

















import { Component, Mixins, Prop } from "vue-property-decorator";
import mixins from "@/mixins";

@Component
class TopBannerPage extends Mixins(mixins.page) {
  @Prop({ default: require("@/assets/images/background_1.png") })
  image!: string;
}
export default TopBannerPage;
